let progressBar = $('.integration-promo-timeline-progress')
let progress = 0
let step = 14.285
let arr = [1, 2, 3, 4, 5, 6, 7]
let bubbles = $('.integration-promo-timeline-bubble')
let textItems = $('.integration-promo-timeline-item')
let smallBlocks = $('.small-blocks').find('.integration-promo-steps-item')
let bigBlocks = $('.big-blocks').find('.integration-promo-steps-item')

let stepsTrack = $('.integration-steps-track')
let stepsProgress = $('.integration-steps-progress')

let stepsTrackHeight = stepsTrack.height()


function combineArrays(arr1, arr2) {
    var combinedArray = [];
    var maxLength = Math.max(arr1.length, arr2.length);

    for (var i = 0; i < maxLength; i++) {
        if (i < arr2.length) {
            combinedArray.push(arr2[i]);
        }
        if (i < arr1.length) {
            combinedArray.push(arr1[i]);
        }
    }

    return combinedArray;
}

function drawLine(step) {
    progress += step
    progressBar.css('width', `${progress}%`);
}

function animateProgressBar(index) {
    (index === 0 || index === 7) ? drawLine(step / 2) : drawLine(step)
}

function initProgressAnimation() {
    for (let i = 0; i < 8; i++) {
        setTimeout(function () {
            animateProgressBar(i)
            i < 7 ? bubbles[i].classList.add('active') : '';
            (i > 0 && i < 7) ? textItems[i-1].classList.add('active') : '';
            i < 7 ? combineArrays(smallBlocks, bigBlocks)[i].classList.add('active') : '';
        }, (i+1)*1000)
    }
}
function scrollLeft(){
    let breakpoints = [0, 150, 300, 500, 700, 900, 1312]
    let outerDiv = $('.integration-promo-steps-item-wrapper-wrap')
    for(let i = 0; i < breakpoints.length; i++){
        setTimeout(function () {
        outerDiv.animate({ scrollLeft: breakpoints[i] }, 500);
        }, (i+1)*1000)
    }

}

if(document.getElementById('integration')){
    setTimeout(function (){
        initProgressAnimation()
        if(window.innerWidth < 1181){
            $('.integration-promo-steps-item-wrapper-wrap').addClass('non-touch')
            scrollLeft()
            setTimeout(function (){
                $('.integration-promo-steps-item-wrapper-wrap').removeClass('non-touch')
            },8000)
        }
    },1000)
    $(window).on("scroll load resize", function() {
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();

        var blockTop = stepsTrack.offset().top;
        var blockBottom = blockTop + stepsTrack.outerHeight();

        if (blockBottom + ($(window).height() / 2) > viewportBottom && blockTop < viewportBottom) {
            if(((viewportBottom - blockTop) - ($(window).height() / 2)) > stepsTrackHeight - 60){
                stepsProgress.css('height', `100%`);
            } else {
                stepsProgress.css('height', `${(100 / stepsTrackHeight * ((viewportBottom - blockTop) - $(window).height() / 2))}%`);
            }

        }
    });


}

